// extracted by mini-css-extract-plugin
export var numpadContainer = "_f6-1";
export var phoneButton = "_f6-0";